export const iconFontAwesomeArrowsShare = (
	<i className="fa-solid fa-share"></i>
);
